import layananApi from '../../services/layananApi'

const SET_LAYANAN = "SET_LAYANAN"
const SET_LAYANAN_ALL = "SET_LAYANAN_ALL"
const SET_LAYANAN_SELECTED = "SET_LAYANAN_SELECTED"
// const SET_DETAIL_LAYANAN_FORM = "SET_DETAIL_LAYANAN_FORM"

const state = {
	layanan: null,
	layananSelected: null,
	layananAll: null
	// detailLayananForm: null
}

const mutations = {
	[SET_LAYANAN](state, data) {
		state.layanan = data
	},
	[SET_LAYANAN_ALL](state, data) {
		state.layananAll = data
	},
	[SET_LAYANAN_SELECTED](state, data) {
		state.layananSelected = data
	},
	// [SET_DETAIL_LAYANAN_FORM](state, data){
	// 	state.detailLayananForm = data
	// }
}

const actions = {
	async fetchLayananByPaket({ commit, getters }, data) {
		let token = getters.getAuthService.token
		return await layananApi.fetchLayananByPaket(token, data.id_paket).then(res => {
			if (res.data.status) {
				let row = res.data.data
				row.forEach(e => {
					e.paket_layanan = e.paket_layanan[0]
				})
				commit(SET_LAYANAN, row)
			}
		})
	},
	async fetchLayananByPaketPublic({ getters }, slug) {
		let token = getters.getAuthService.token
		return await layananApi.fetchLayananByPaketPublic(token, slug)
	},
	setLayanan({ commit }, data) {
		commit(SET_LAYANAN, data)
	},
	async showLayananPublic({ getters }, slug) {
		let token = getters.getAuthService.token
		return await layananApi.showLayananPublic(token, slug)
	},
	async fetchAllLayanan({ commit, getters }, data) {
		let token = getters.getAuthService.token
		return await layananApi.fetchAllLayanan(token, data).then(res => {
			// console.log(res)
			if (res.data.status) {
				commit(SET_LAYANAN_ALL, res.data.data)
			}
		})
	},
	emptyLayanan({ commit }) {
		commit(SET_LAYANAN, null)
	},
	selectLayanan({ commit }, data) {
		commit(SET_LAYANAN_SELECTED, data)
	},
	async storeLayanan({ getters }, data) {
		let token = getters.getAuthService.token
		return await layananApi.storeLayanan(token, data)
	},
	async updateLayanan({ getters }, data) {
		let token = getters.getAuthService.token
		return await layananApi.updateLayanan(token, data.id, data.form)
	},
	async hapusLayanan({ getters }, id) {
		let token = getters.getAuthService.token
		return await layananApi.hapusLayanan(token, id)
	},
	async updateLayananDokumen({ getters }, data) {
		let token = getters.getAuthService.token
		return await layananApi.updateLayananDokumen(token, data.id, data.form)
	},
	async storeLayananDokumen({ getters }, data) {
		let token = getters.getAuthService.token
		return await layananApi.storeLayananDokumen(token, data.id, data.form)
	},
	async deleteLayananDokumen({ getters }, data) {
		let token = getters.getAuthService.token
		return await layananApi.deleteLayananDokumen(token, data.id, data.form)
	},
	async uploadContohForm({ getters }, data) {
		let token = getters.getAuthService.token
		return await layananApi.uploadContohForm(token, data.id, data.form)
	}
}

const getters = {
	getLayanan: state => {
		return state.layanan
	},
	getLayananSelected: state => {
		return state.layananSelected
	},
	getLayananAll: state => {
		return state.layananAll
	},
	// getDetailLayananForm: state => {
	// 	return state.detailLayananForm
	// }
}

export default {
	state,
	mutations,
	actions,
	getters
}